import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import { motion} from "framer-motion";

export default function NewSubBanner({
  customClass = "",
  heading,
  bannerImage,
  customBannerColor,
  bannerImageAlt,
  logoBanner = false,
}) {

  const titleVariants = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };

  return (
    <section className={`${styles.root} ${customClass} mb-4`}>
      <Container>
        <div
          className="content-wrapper rounded-3 shadow position-relative overflow-hidden p-lg-5 p-4"
    
        >
        {bannerImage && (
  <div className="banner-image-wrapper">
    <SourceFlowImage
      src={bannerImage}
      size={`${logoBanner ? "800x" : "800x800"}`}
      alt={bannerImageAlt}
      className={`card-img default-banner`}
      width="100%"
      height="100%"
    />
  </div>
)}

          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <motion.h1
              initial="hidden"
              animate="visible"
              variants={titleVariants}
              className="position-relative post-title"
            >
              {heading}
            </motion.h1>
          </div>

        </div>
      </Container>
    </section>
  );
}